export default "__VITE_PUBLIC_ASSET__2188717e__"